/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  desciptionCreated: {
    id: "b2b.provozni-informace-detail.description-label.created",
    defaultMessage: "Created"
  },
  descriptionEdited: {
    id: "b2b.provozni-informace-detail.description-label.edited",
    defaultMessage: "Last updated"
  },
  pageHeadingEdit: {
    id: "b2b.provozni-informace-detail.header-action.edit",
    defaultMessage: "EDIT"
  },
  emptyMessage: {
    id: "b2b.provozni-informace-detail.emptyMessage",
    defaultMessage: "No operational information found"
  }
});

export default () => useMessages(MESSAGES);
